import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';

const bg = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/back.png';
const card = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/touch-image.png';
const p1 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/people-first.png';
const p2 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/people-second.png';
const p3 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/people-third.png';
const p4 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/people-fourth.png';
const p5 = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/people-fifth.png';

const StayInTouch = () => {
  const isMobile = useMediaQuery('(max-width:439px)');
  const isTablet = useMediaQuery('(min-width:440px) and (max-width:1024px)');

  const titleFontSize = isTablet ? '30px' : '50px';
  const descFontSize = isTablet ? '14px' : '16px';

  return (
    <Box
      sx={{
        overflowX: 'hidden',
        width: '100%',
        bgcolor: '#ECECEC',
        position: 'relative',
      }}
    >
      {/* ===== Mobile Version ===== */}
      {isMobile ? (
        <Box sx={{ px: 2, py: 5, textAlign: 'center', position: 'relative' }}>
          {/* Top Avatars */}
          <Box sx={{ position: 'relative', height: 120, mb: 2 }}>
            <Box component="img" src={p1} alt="Avatar 1" sx={{
              width: 80, height: 80, position: 'absolute',
              top: '0%', left: '-9%', zIndex: 2
            }} />
            <Box component="img" src={p2} alt="Avatar 2" sx={{
              width: 30, height: 30, position: 'absolute',
              top: '70%', left: '17%', zIndex: 2
            }} />
            <Box component="img" src={p3} alt="Avatar 3" sx={{
              width: 45, height: 45, position: 'absolute',
              top: '5%', left: '30%', zIndex: 2
            }} />
          </Box>

          {/* Title */}
          <Typography sx={{
            color: '#000000', fontFamily: 'Unbounded, sans-serif',
            fontWeight: 500, fontSize: '30px', lineHeight: '130%', textAlign: 'left', mt: 3
          }}>
            Stay in touch with<br /> your Connections.
          </Typography>

          {/* Image with background */}
          <Box sx={{ position: 'relative', mt: 11, mb: 5 }}>
            <Box component="img" src={bg} alt="Background" sx={{
              position: 'absolute', top: '50%', left: '50%',
              transform: 'translate(-50%, -50%) scale(1.1)',
              width: '100%', height: 'auto',
              objectFit: 'contain', zIndex: 0, pointerEvents: 'none'
            }} />
            <Box component="img" src={card} alt="User Card" sx={{
              width: '100%', maxWidth: '420px', height: 'auto',
              mx: 'auto', position: 'relative', zIndex: 1
            }} />
          </Box>

          {/* Bottom Avatars */}
          <Box sx={{ position: 'relative', height: 90 }}>
            <Box component="img" src={p4} alt="Avatar 4" sx={{
              width: 30, height: 30, position: 'absolute',
              top: 10, right: '12%', zIndex: 2
            }} />
            <Box component="img" src={p5} alt="Avatar 5" sx={{
              width: 70, height: 70, position: 'absolute',
              top: '50%', right: '-11%', zIndex: 1
            }} />
          </Box>

          {/* Description */}
          <Typography sx={{
            color: '#000000', fontFamily: 'Sora, sans-serif',
            fontWeight: 400, fontSize: '15px', lineHeight: '26px', textAlign: 'left', mb: 5
          }}>
            This is the address book you’ve always<br /> wished for — a place to rediscover past<br /> connections and spark new ones. See who’s<br /> online, invite them for a quick chat, or<br /> browse their business card with socials and<br /> more. It’s not just networking — it’s the<br /> future of networking.
          </Typography>
        </Box>
      ) : (
        // ===== Desktop & Tablet Version =====
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            py: 10,
            px: 5,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              maxWidth: '1920px',
              minHeight: '1000px',
            }}
          >
            {/* Text and Avatars */}
            <Box
              sx={{
                width: isTablet ? '50%' : '40%',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                pl: 5,
              }}
            >
              <Box component="img" src={p1} alt="Avatar 1" sx={{
                width: isTablet ? 120 : 150,
                height: isTablet ? 120 : 150,
                transform: 'scale(0.8)',
                position: 'absolute',
                top: '0%',
                right: '20%',
                objectFit: 'cover'
              }} />
              <Box component="img" src={p2} alt="Avatar 2" sx={{
                width: isTablet ? 96 : 120,
                height: isTablet ? 96 : 120,
                transform: 'scale(0.8)',
                position: 'absolute',
                top: '10%',
                right: '0%',
                objectFit: 'cover'
              }} />
              <Box component="img" src={p3} alt="Avatar 3" sx={{
                width: isTablet ? 64 : 80,
                height: isTablet ? 64 : 80,
                transform: 'scale(0.8)',
                position: 'absolute',
                top: '20%',
                right: '17%',
                objectFit: 'cover'
              }} />

              {isTablet ? (
                <Box>
                  <Typography sx={{
                    color: '#000000', fontFamily: 'Unbounded, sans-serif',
                    fontWeight: 500, fontSize: titleFontSize, lineHeight: '120%',
                    mb: 4
                  }}>
                    Stay in touch<br /> with your<br /> Connections.
                  </Typography>
                  <Typography sx={{
                    color: '#000000', fontFamily: 'Sora, sans-serif',
                    fontWeight: 400, fontSize: descFontSize, lineHeight: '26px',
                    letterSpacing: '0.3px'
                  }}>
                    This is the address book you’ve always<br /> wished for — a place to rediscover past<br /> connections and spark new ones. See who’s<br /> online, invite them for a quick chat, or<br /> browse their business card with socials and<br /> more. It’s not just networking — it’s the<br /> future of networking.
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography sx={{
                    color: '#000000', fontFamily: 'Unbounded, sans-serif',
                    fontWeight: 500, fontSize: titleFontSize, lineHeight: '120%',
                    mb: 4
                  }}>
                    Stay in touch with your Connections.
                  </Typography>
                  <Typography sx={{
                    color: '#000000', fontFamily: 'Sora, sans-serif',
                    fontWeight: 400, fontSize: descFontSize, lineHeight: '26px',
                    letterSpacing: '0.3px'
                  }}>
                    This is the address book you’ve always wished for — a place to
                    rediscover past connections and spark new ones. See who’s
                    online, invite them for a quick chat, or browse their business
                    card with socials and more. It’s not just networking — it’s the
                    future of networking.
                  </Typography>
                </Box>
              )}

              <Box component="img" src={p4} alt="Avatar 4" sx={{
                width: isTablet ? 64 : 80,
                height: isTablet ? 64 : 80,
                transform: 'scale(0.9)',
                position: 'absolute',
                bottom: '20%',
                right: '0%',
                objectFit: 'cover'
              }} />
              <Box component="img" src={p5} alt="Avatar 5" sx={{
                width: isTablet ? 144 : 180,
                height: isTablet ? 144 : 180,
                transform: 'scale(0.7)',
                position: 'absolute',
                bottom: '5%',
                right: '-25%',
                objectFit: 'cover'
              }} />
            </Box>

            {/* Background and Card */}
            <Box
              sx={{
                position: 'relative',
                width: isTablet ? '50%' : '60%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                pr: 5,
              }}
            >
              <Box component="img" src={bg} alt="Background" sx={{
                position: 'absolute', top: '50%', left: '55%',
                transform: 'translate(-50%, -50%) scale(1)',
                width: '100%', height: 'auto', objectFit: 'contain',
                zIndex: 0, pointerEvents: 'none'
              }} />
              <Box component="img" src={card} alt="User Card" sx={{
                width: '90%', height: 'auto', zIndex: 1, position: 'relative'
              }} />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default StayInTouch;
